// Iter 649 — Rincian Pantau Produksi Offline: posisi sekarang + riwayat pengerjaan per divisi (baca-saja).
import React, { useEffect, useState } from "react";
import axios from "axios";
import { X, RefreshCw } from "lucide-react";
import { notaLabel } from "./offline_history_panel";
import { OwnerManualMenu } from "./owner_manual";
import { OwnerForceActions } from "./owner_force";

const BASE = process.env.REACT_APP_BACKEND_URL;
const fmt = (iso) => {
  if (!iso) return "Belum ada catatan";
  try { return new Date(iso).toLocaleString("id-ID", { timeZone: "Asia/Jakarta", day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }); }
  catch { return iso; }
};

export function OfflineDetailModal({ orderNumber, onClose, onOpenNota, onChanged }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const load = () => {
    setErr("");
    axios.get(`${BASE}/api/production/monitoring/offline-detail/${encodeURIComponent(orderNumber)}`, { withCredentials: true, timeout: 20000 })
      .then(r => setD(r.data)).catch(e => setErr(e?.response?.data?.detail || "Gagal memuat rincian. Coba lagi."));
  };
  useEffect(load, [orderNumber]); // eslint-disable-line react-hooks/exhaustive-deps

  return <div className="modal-overlay" onClick={onClose} data-testid="monitor-offline-detail-overlay">
    <div className="modal-content omd" onClick={e => e.stopPropagation()}>
      <div className="modal-header">
        <h3 data-testid="monitor-offline-detail-title">Rincian · {orderNumber}</h3>
        <span style={{ marginLeft: "auto", marginRight: 8 }}><OwnerManualMenu orderNumber={orderNumber} onDone={load}/></span>
        <button type="button" onClick={onClose} aria-label="Tutup" data-testid="monitor-offline-detail-close"><X size={18}/></button>
      </div>
      <div className="modal-body">
        {err && <div className="omd-err" role="alert" data-testid="monitor-offline-detail-error">{err}
          <button type="button" onClick={load} data-testid="monitor-offline-detail-retry"><RefreshCw size={13}/> Coba Lagi</button></div>}
        {!d && !err && <p className="muted small">Memuat rincian…</p>}
        {d && <OwnerForceActions orderNumber={orderNumber} onDone={() => { load(); onChanged && onChanged(); }}/>}
        {d && <Body d={d} onOpenNota={onOpenNota}/>}
      </div>
    </div>
  </div>;
}

function Body({ d, onOpenNota }) {
  return <>
    <div className="omd-id">
      <img src={`${BASE}${d.thumb}`} alt="Mockup" onError={e => { e.currentTarget.style.visibility = "hidden"; }}/>
      <div>
        <strong data-testid="omd-customer">{d.customer_name || "—"}</strong>
        <span>{d.order_number} · {notaLabel(d.order_status)}</span>
        {d.deadline && <span>Batas selesai: {d.deadline}</span>}
        {onOpenNota && <button type="button" className="omd-link" onClick={onOpenNota} data-testid="omd-open-nota">Buka Nota</button>}
      </div>
    </div>
    <div className="omd-prods" data-testid="omd-products">
      {d.products.map(p => <div key={p.id} className="omd-prod">
        <b>{p.name}</b>{p.material ? ` · ${p.material}` : ""} · <b>{p.qty} pcs</b>
        {p.sizes.length > 0 && <div className="omd-sizes">{p.sizes.map((s, i) => <span key={i}>{s.size}{s.color ? ` ${s.color}` : ""} · {s.qty}</span>)}</div>}
      </div>)}
    </div>

    <h4 className="omd-h">Posisi Sekarang</h4>
    <p className="omd-note">Posisi pekerjaan di sistem, belum tentu sama dengan lokasi fisik barang.</p>
    {d.current.map((c, i) => <div key={i} className="omd-now" data-testid={`omd-current-${i}`}>
      {d.current.length > 1 && <div className="omd-now-prod">{c.product}</div>}
      <div className="omd-now-main"><span className="omd-div">{c.division}</span><b>{c.status}</b></div>
      {c.pic && <div>Operator: <b>{c.pic}</b></div>}
      {c.parallel.map(r => <div key={r.division} className={`omd-track ${r.status === "Selesai" ? "ok" : "wait"}`}>
        <span>{r.division} · {r.task}</span><b>{r.status}</b><small>{r.pic}{r.at ? ` · ${fmt(r.at)}` : ""}</small></div>)}
      <div className="omd-last">Terakhir diserahkan: {c.last_handover ? <><b>{c.last_handover.by}</b>{c.last_handover.from ? ` (${c.last_handover.from})` : ""} · {fmt(c.last_handover.at)}</> : "Belum ada catatan"}</div>
    </div>)}

    <h4 className="omd-h">Operator yang Terlibat</h4>
    <div className="omd-divs" data-testid="omd-divisions">
      {d.divisions.map(x => <div key={x.division} className="omd-divrow">
        <span>{x.division}</span><b>{x.people.length ? x.people.join(", ") : "Belum ada catatan"}</b><small>{fmt(x.last_at)}</small></div>)}
    </div>

    <h4 className="omd-h">Riwayat Pengerjaan</h4>
    {d.timeline.length === 0 ? <p className="muted small">Belum ada catatan.</p> :
      <ol className="omd-tl" data-testid="omd-timeline">
        {d.timeline.map((e, i) => <li key={i} className={`omd-ev omd-${e.kind}`}>
          <div className="omd-ev-top"><span className="omd-div">{e.division}</span><small>{fmt(e.at)}</small></div>
          <div className="omd-ev-title">{e.title}{e.product ? ` — ${e.product}` : ""}</div>
          {(e.who || e.detail) && <div className="omd-ev-who">{e.who && <b>{e.who}</b>}{e.who && e.detail ? " · " : ""}{e.detail}</div>}
        </li>)}
      </ol>}
  </>;
}
